import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo1_contrasted from "../assets/logo1_contrasted.png";

function DashboardNavbar() {
  const navigate = useNavigate();
  const handleLogout = () => {
    // Clear the localStorage or other stored user data
    localStorage.removeItem("name");
    localStorage.removeItem("user_type");
    // Navigate to the login or home page
    navigate("/");
  };

  return (
    <>
      {/* Navbar Code */}
      <nav
        className="navbar navbar-expand-lg sticky-top"
        style={{ backgroundColor: "#008cba" }}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logo1_contrasted} alt="logo" className="logo1" />
            <span className="ms-2 web-name text-white fw-bold">Screenify</span>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon landnav-toggler"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto text-center navfont">
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle text-white hover-effect"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Master Data Management
                </Link>
                <ul className="dropdown-menu fw-normal">
                  <li>
                    <Link className="dropdown-item" to="/jd_dashboard">
                      JD Management
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/user_dashboard">
                      User Management
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/client_dashboard">
                      Client Management
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Dashboards Dropdown */}
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle text-white hover-effect"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dashboards
                </Link>
                <ul className="dropdown-menu fw-normal">
                  <li>
                    <Link className="dropdown-item" to="/reports_dashboard">
                      Reports & Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/employee_dashboard">
                      Employee Dashboard
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle text-white"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa-regular fa-circle-user fa-xl"></i>{" "}
                  {/* Profile Icon */}
                </Link>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  title="User Profile"
                >
                  <li className="dropdown-item">
                    <div className="d-flex flex-column">
                      <span>
                        <strong>Name:</strong> {localStorage.getItem("name")}
                      </span>{" "}
                      {/* Display Name */}
                      <span>
                        <strong>Role:</strong>{" "}
                        {localStorage.getItem("user_type")}
                      </span>{" "}
                      {/* Display Role */}
                    </div>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>{" "}
                  {/* Divider */}
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      <i className="fa-solid fa-right-from-bracket me-1"></i>{" "}
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default DashboardNavbar;
